import { Injectable } from '@angular/core';
import {MediaConnection} from "peerjs";
import {log} from "../functions";
import {ReplaySubject} from "rxjs";
import {Chat, IMessengerConnector, Message} from "../types/all.type";
import {ModalVideoCallsComponent} from "../components/modal-video-calls/modal-video-calls.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {
  ModalVideoCallIncomingComponent
} from "../components/modal-video-calls/modal-video-call-incoming/modal-video-call-incoming.component";

@Injectable({
  providedIn: 'root'
})
export class CallService {
  messageCallText = 'Входящий вызов, что бы ответить на звонок, перейдите по ссылке: ';
  call = false;
  public startCall$: ReplaySubject<'video' | 'share' | 'audio'> = new ReplaySubject();
  public endCall$: ReplaySubject<void> = new ReplaySubject();
  isCall = false;
  constructor(
    private modalService: BsModalService
  ) {}
  startCall(chat: Chat, Service: IMessengerConnector, type: 'video' | 'share' | 'audio' = 'video', sendMessage = true) {
    this.modalService.show(
      ModalVideoCallsComponent,
      {
        class: 'modal-lg',
        ignoreBackdropClick: true,
        initialState: {
          Service: Service,
          chat: chat,
          type,
        }
      }
    );
    if(sendMessage) {
      Service.sendMessage({
        chat_id: chat.id,
        text: this.messageCallText +
          location.protocol + '//' + location.host + '/call/' + Service.type + chat.id
      })
    }
  }

  replaceCallMessage(message: Message, Service: IMessengerConnector, eventCall = false) {
    const [url] = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g.exec(message.text) || [''];


    if(message.text?.includes(this.messageCallText)) {
      message.text = '';
      message.text_list = message.out ? 'Исходящий звонок' : 'Входящий звонок';
      message.attachments = [
        {
          type: "call",
          date: new Date().getTime(),
          call: {
            initiator_id: Service.arProfile.id,
            time: new Date().getTime(),
            duration: 0,
          }
        }
      ]
      // Parse chat id (room call)
      if(url) {
        const {pathname} = new URL(url);
        const chatId = pathname.replace('/call/' + Service.type, '');
        if (chatId && eventCall && !message.out) {
          this.modalService.show(
            ModalVideoCallIncomingComponent,
            {
              class: 'modal-lg',
              ignoreBackdropClick: true,
              initialState: {
                Service: Service,
                chat: <any>{
                  id: chatId
                },
                type: 'video',
              }
            }
          );
        }
      }
      return true;
    }
    return false;
  }
}
